<template>
    <div>
        <loader v-show="!loaded" />
        <div v-if="routeName">
            <a href="https://drive.google.com/file/d/1ghp2d3_oaKg_DvJQxufXlXWvIkKQSJOl/view?usp=sharing"
                target="_blank">CR Risk Layer Map Guide</a>
        </div>   
        <iframe id="iframeMap" v-if="loaded" :src="iframe.src" :frameborder="0" ref="mapIframe"
            onload='javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px"; o.style.maxHeight="83vh";}(this));'
            style="width:100%;border:none;overflow:hidden;max-height:83vh;" :height="iframe.style.height"></iframe>
    </div>

</template>
<script>
import loggingService from '../services/util/loggingService'
import { mapState } from 'vuex'
import mediaService from '../services/mediaService'
import gisService from '../services/gisService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
//import { loadEsri } from '../services/esriLoadService'
import loader from '@/components/Loader'

export default {
    components: {
        loader
    },
    name: 'MapNew',
    props: {
        mediaTypeId: {
            default: function () {
                if (this.$route.query.mediaTypeId) {
                    return this.$route.query.mediaTypeId
                }
                return null
            }
        },
        parentId: {
            default: function () {
                if (this.$route.query.parentId) {
                    return this.$route.query.parentId
                }
                return null
            }
        },
        smithsonianNo: {
            default: null
        },
        invDbNumber: {
            default: null
        },
        invActivities: {
            default: () => []
        },
        crrShowShapefile: {
            default: false
        },
        loadOnMount: {
            default: true
        }
    },
    computed: {
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        smithNoFormatted: function () {
            if (this.smithsonianNo) return this.smithsonianNo.replace(/\s+/g, '')
            else return null
        },
        isPublicUser: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.PublicUser])
        },
        routeName: function () {
            return this.$route.name === 'MapPublic'
        }
    },
    watch: {
        routeName: function (value) {
            this.createMap()
        }
    },
    data () {
        return {
            isDebug: false,
            loaded: false,
            iframe: {
                src: '',
                style: {
                    position: 'absolute',
                    width: '100%',
                    height: window.innerHeight * 0.8
                }
            },
            mediaShapeFiles: []
        }
    },
    mounted () {
        localStorage.removeItem('shpoMapFeatDataList')
        if (this.loadOnMount) this.createMap()
    },
    methods: {
        createMap () {
            // loadEsri('map.createMap').then(() => {
            this.loaded = false
            let isPublic = this.routeName
            var token = ''
            var arcGisOnlineToken = ''
            if (this.shpoUserDto) {
                if (this.shpoUserDto.arcGisOnlineToken) {
                    arcGisOnlineToken = this.shpoUserDto.arcGisOnlineToken.token
                }
                if (this.shpoUserDto.gisToken) {
                    token = this.shpoUserDto.gisToken.token
                }
            }

            var iframeSrc = `../../static/gis/WebMap00/index.html?token=${token}&arcGisOnlineToken=${arcGisOnlineToken}&public=${isPublic}`
            gisService.setGisServiceUrls(token)

            let searchTerm = this.invDbNumber || this.smithNoFormatted

            if (this.mediaTypeId && this.parentId) {
                mediaService.list(this.$http, this.mediaTypeId, null, this.parentId).then((mediaList) => {
                    this.mediaShapeFiles = mediaList.data.filter((media) => {
                        return media.isShapeFile === true
                    })

                    //has shapefiles and (1. show crr shapefile, or 2. not in cr/inv)
                    if (this.mediaShapeFiles && this.mediaShapeFiles.length > 0 && (this.crrShowShapefile || !searchTerm)) {
                        this.loadMapWithShapefiles(iframeSrc)
                    } else {
                        this.loadMapWithSearchTerm(iframeSrc, searchTerm)
                    }
                })
            } else {
                this.loadMapWithSearchTerm(iframeSrc, searchTerm)
            }
            // if (searchTerm) {
            //     this.iframe.src = iframeSrc + `&searchTerm=${searchTerm}`
            //     this.loaded = true
            // } else if (this.mediaTypeId && this.parentId) {
            //     gisService.setGisServiceUrls(token)
            // } else {
            //     this.iframe.src = iframeSrc
            //     this.loaded = true
            // }
        },
        reloadMap () {
            document.getElementById('iframeMap').contentWindow.location.reload()
        },
        loadMapWithSearchTerm (iframeSrc, searchTerm) {
            this.iframe.src = iframeSrc + (searchTerm ? `&searchTerm=${searchTerm}` : '')
            this.loaded = true
        },
        loadMapWithShapefiles (iframeSrc) {
            loggingService.log(this.isDebug, 'Map', 'setShapefiles')

            // var symbol = new SimpleFillSymbol(SimpleFillSymbol.STYLE_SOLID,
            //     new SimpleLineSymbol(SimpleLineSymbol.STYLE_SOLID,
            //     new Color([0, 38, 115]), 3), new Color([0, 169, 230, 0.25])
            // )
            // var renderer = new SimpleRenderer(symbol)

            var featureDataList = []
            var filteredList = this.mediaShapeFiles
            if (filteredList && filteredList.length > 0) {
                //found at least one shapefile, iterate through and get the .zip
                //then send out to service
                var mediaPromises = []
                for (var i = 0; i < filteredList.length; i++) {
                    var media = filteredList[i]
                    var featureData = {
                        featureCollection: {},
                        filename: ''
                    }
                    mediaPromises.push(mediaService.get(this.$http, media.mediaId, media.mediaTypeId, null, media.parentId))
                    featureData.filename = media.filename
                    featureDataList.push(featureData)
                }
                Promise.all(mediaPromises).then((shapefiles) => {
                    loggingService.log(this.isDebug, 'Map', 'mediaService.get.then')
                    var featurePromises = []
                    // mapService.getShpoServiceUrl().then(() => {
                    shapefiles.forEach(shapefile => {
                        featurePromises.push(gisService.getFeaturesFromZip(shapefile.data, 'shapefile', 4326))
                    })
                    Promise.all(featurePromises).then((featurePromiseResults) => {
                        featurePromiseResults.forEach((features, index) => {
                            // console.log(features.data)
                            featureDataList[index].featureCollection = JSON.stringify(features.data.featureCollection)
                            // var extent
                            // for (var i = 0; i < features.data.featureCollection.layers.length; i++) {
                            //     var lyr = features.data.featureCollection.layers[i]
                            //     if (!extent) {
                            //         extent = new Extent(lyr.layerDefinition.extent)
                            //     } else {
                            //         extent = extent.union(new Extent(lyr.layerDefinition.extent))
                            //     }
                            //     //apply style
                            //     var featLayer = new FeatureLayer(lyr)
                            //     featLayer.setRenderer(renderer)
                            //     //mapService.map.addLayer(featLayer)
                            //     featureData.featureList.push(featLayer)
                            // }
                            // //mapService.map.setExtent(extent.expand(2.25))
                            // featureData.extent = extent
                        })
                        // console.log('featureDataList')
                        // console.log(featureDataList)
                        localStorage.setItem('shpoMapFeatDataList', JSON.stringify(featureDataList))
                        //set iframe
                        this.iframe.src = iframeSrc
                        this.loaded = true
                    }).catch(err => {
                        loggingService.log(this.isDebug, 'Map', 'mapService.getFeaturesFromZip.error')
                        loggingService.logRaw(this.isDebug, err)
                        //set iframe
                        this.iframe.src = iframeSrc
                        this.loaded = true
                    })
                    // })
                })
                .catch(err => {
                    loggingService.log(this.isDebug, 'Map', 'mapService.getFeaturesFromZip.error')
                    loggingService.logRaw(this.isDebug, err)
                })
            } else {
                //set iframe
                this.iframe.src = iframeSrc
                this.loaded = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// MapNew.vue?0d8577b8